<template>
  <v-container id="userView">
    <v-breadcrumbs :items="breadcrumbs" divider="-" />
    <v-row>
      <v-col>
          <list-sessions :sessions="sessions" :breadcrumbs="breadcrumbs" :title="displayName" />
        </v-col>
    </v-row>
    <v-row>
      <v-col>
        <activity-view :user="userID" :title="activityTitle" :user-name="displayName" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import 'firebase/auth'
  import activityView from './ActivityView.vue'
  import ListSessions from '@/components/base/list-sessions/listSessions.vue'
  import api from '@/helpers/api.js'


  export default {
    name: 'UserView',

    components: {
      'activity-view': activityView,
      'list-sessions': ListSessions,
    },

    data () {
      return {
        classLearner: undefined,
        user: undefined,
        sessions: [],
        moduleID: undefined,
        loading: false,
      }
    },

    computed: {
      activityTitle () {
        return this.user ? this.$t('classLearner.progress.title', [this.user.displayName]) : this.$t('global.loading')
      },
      userID () {
        return this.$route.params.id
      },
      displayName () {
        return this.user ? this.user.displayName + ' ' + this.$t('sessionList.progress') : this.$t('global.loading')
      },
      breadcrumbs () {
        return [
          {
            text: this.$t('nav.users'),
            disabled: false,
            href: '#/admin/users/',
          },
          {
            text: this.user ? this.user.displayName : this.$t('global.loading'),
            disabled: true,
            href: '#/admin/users/' + this.$route.params.id,
          },
        ]
      },
    },

    async mounted () {
      this.loading = true
      try {
        const [user, sessions] = await Promise.all(
          [
            api.getUser(this.userID),
            api.getSessionsByUser(this.userID),
          ])
        // console.log('sessions src ', sessions.length)
        this.sessions = sessions
        this.user = user
      } catch (error) {
        console.log(error)
        this.loading = false
      }
      this.loading = false
    },

    methods: {
    },

  }
</script>

<style>
</style>
